// @flow
import axios from "axios";

const DiscountServerRequest = function(quantity: number) {
  return axios
    .get("/payment/bulk_discounts/new", {
      params: {
        quantity: quantity
      }
    })
    .then(successHandler)
    .catch(errorHandler);
};

const successHandler = function(response) {
  return response.data.discount;
};

const errorHandler = function(error) {
  return 0;
};

export default DiscountServerRequest;



// WEBPACK FOOTER //
// ./app/javascript/order_form/discount_server_request.js